import { render, staticRenderFns } from "./TwDashBoardComments.vue?vue&type=template&id=ae6765e2&scoped=true&"
import script from "./TwDashBoardComments.vue?vue&type=script&lang=js&"
export * from "./TwDashBoardComments.vue?vue&type=script&lang=js&"
import style0 from "./TwDashBoardComments.vue?vue&type=style&index=0&id=ae6765e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6765e2",
  null
  
)

export default component.exports